const ProgressBarThin = ({ progress, height = 3 }) => {
    return (
        <div style={{ background: 'rgba(var(--app-ink-rgb), 0.2)', width: '100%', height: `${height}px`, borderRadius: '2px' }}>
            <div style={{
                width: `${progress * 100}%`,
                height: '100%',
                background: 'var(--app-text-secondary)',
                borderRadius: '2px'
            }} />
        </div>
    );
};

export default ProgressBarThin;
